import { ADD, ADD_MULTIPLE, UPDATE, REMOVE } from './constants';

export const addAction = (picture) => ({
  type: ADD,
  picture,
});

export const addMultipleAction = (pictures) => ({
  type: ADD_MULTIPLE,
  pictures,
});

export const updateAction = (picture) => ({
  type: UPDATE,
  picture,
});

export const removeAction = (id) => ({
  type: REMOVE,
  id,
});
